module.exports = __webpack_public_path__ + "img/Ceuta & Melilla.f38b1403.svg";